var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-kp",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M92.213 7.828h593.6v485.5h-593.6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "matrix(.86254 0 0 1.0546 -79.537 -8.255)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.063,
    fill: "#fff",
    d: "M991.81 492.88H4.18V8.38h987.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e5698",
    d: "M991.81 405.21H4.18v87.672h987.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c60000",
    d: "M991.81 384.9H4.18V116.35h987.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3e5698",
    d: "M991.81 8.374H4.18v87.672h987.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.088 250.648c0 60.167-61.572 108.94-137.523 108.94-75.953 0-137.523-48.775-137.523-108.94 0-60.167 61.572-108.94 137.523-108.94 75.953 0 137.523 48.774 137.523 108.94z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c40000",
    d: "M402.854 326.75l-66.077-38.59-67.132 39.129 26.38-62.896-66.148-38.516 82.374-.274 26.242-62.933 24.535 62.724 82.376-.385-67.213 39.046z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKp);
export default __webpack_public_path__ + "static/media/kp.5db0bfa7d1c4a4f12534f7046f428f16.svg";
export { ForwardRef as ReactComponent };